import { render, staticRenderFns } from "./my-approval-list.vue?vue&type=template&id=dabd1e2e&"
import script from "./my-approval-list.vue?vue&type=script&lang=js&"
export * from "./my-approval-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports